import React from "react";

import { ShippingContextProvider } from "../../hooks";
import OutsidePageContent from "./OutsidePageContent.jsx";

export const OutsideProcessing = ({ defaultLocation }) => {
  return (
    <ShippingContextProvider key="routeIds" returning>
      <OutsidePageContent defaultLocation={defaultLocation} />
    </ShippingContextProvider>
  );
};

export default OutsideProcessing;
